import Image from 'next/image';
import { MyLink } from '@app/shared';
import { ActionItemType } from '../../../module/types/actionSchema';
import config from '@app/config';

import styles from './ActionItem.module.scss';

export const ActionItem = ({ announcePicture, href, name }: ActionItemType) => {
  return (
    <MyLink className={styles.Container} href={`/actions/${href}/`}>
      <div>
        <Image
          src={`${config.baseImageUrl}/themes/tireshop2/images/actions/${announcePicture}`}
          alt={name}
          layout={'responsive'}
          width={634}
          height={414}
        />
      </div>
    </MyLink>
  );
};
